const FETCH_ROLES_PERMISSIONS = 'FETCH_ROLES_PERMISSIONS'
const SET_ROLES_PERMISSIONS = 'SET_ROLES_PERMISSIONS'
const FETCH_CREATE_AGENCIES_PERMISSIONS = 'FETCH_CREATE_AGENCIES_PERMISSIONS'
const SET_CREATE_AGENCIES_PERMISSIONS = 'SET_CREATE_AGENCIES_PERMISSIONS'
const SET_ROLE = 'SET_ROLE'


const state = {
    roles: [],
    role: {},
    permissions: [],
    create_agencies_permissions: [],

}

const mutations = {

    [SET_ROLES_PERMISSIONS](state, data) {

        state.roles = data.roles
        state.permissions = data.permissions
    },
    [SET_CREATE_AGENCIES_PERMISSIONS](state, data) {

        state.create_agencies_permissions = data
    },

    [SET_ROLE](state, data) {

        state.role = data
    },

}


const actions = {

    [FETCH_ROLES_PERMISSIONS]: async({ commit }) => {
        const response = await axios.get('roles')
        commit(SET_ROLES_PERMISSIONS, response.data)
    },

    [FETCH_CREATE_AGENCIES_PERMISSIONS]: async({ commit }) => {
        let response = await axios.get('permissions/create-agencies')
        commit(SET_CREATE_AGENCIES_PERMISSIONS, response.data)
    }


}

export default {
    state,
    mutations,
    actions
}